export default "__VITE_ASSET__362b5e70__"